import { render, staticRenderFns } from "./AdminPageShell.vue?vue&type=template&id=32111a86"
import script from "./AdminPageShell.vue?vue&type=script&lang=js"
export * from "./AdminPageShell.vue?vue&type=script&lang=js"
import style0 from "./AdminPageShell.vue?vue&type=style&index=0&id=32111a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports